import { Skeleton } from "antd";
import Parser from "html-react-parser";
import Notiflix from "notiflix";
import React, { useContext, useEffect, useState } from "react";
import { BsTwitterX } from "react-icons/bs";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaShareAlt,
  FaWhatsapp
} from "react-icons/fa";
import { HiOutlineChevronLeft, HiOutlineChevronRight } from "react-icons/hi";
import { MdContentCopy } from "react-icons/md";
import { useHistory, useParams } from "react-router-dom";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton
} from "react-share";
import Slider from "react-slick";
import { store } from "../../context/store";
import PostApiCall from "../../helpers/Api";
import GetSeoData from "../../helpers/GetSeoData";
import AddToCartQty from "../AddToCartQty/AddToCartQty";
import AddToCart from "../Helpers/AddToCart";
import LoginModal from "../Login/LoginModal";
import ProductReviews from "../ProductReviews/ProductReviews";
import "./ProductDetail.css";
import RelatedProducts from "./RelatedProducts";

function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style }} onClick={onClick}>
      <HiOutlineChevronRight />
    </div>
  );
}

function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style }} onClick={onClick}>
      <HiOutlineChevronLeft />
    </div>
  );
}

export default function ProductDetail() {
  const params = useParams();
  let history = useHistory();
  const [productDetail, setProductDetail] = useState([]);
  const [selectedVariant, setSelectedVariant] = useState([]);
  const [relatedProductDetail, setRelatedProductDetail] = useState([]);
  const [variantImage, setVariantImage] = useState(null);
  const [variantId, setVariantId] = useState(null);
  const [variantName, setVariantName] = useState(null);
  const [itemName, setItemName] = useState(null);
  const [variantList, setVariantList] = useState(null);
  const [mrp, setMRP] = useState(null);
  const [discountPrice, setDiscountPrice] = useState(null);
  const [youSave, setYouSave] = useState(null);
  const [savePer, setSavePer] = useState(null);
  const [stock, setStock] = useState(null);
  const [categoryName, setCategoryName] = useState(null);
  const [rating, setRating] = useState(null);
  const [weight, setWeight] = useState(null);
  const [countryOfOrigin, setCountryOfOrigin] = useState(null);
  const [shortDescription, setShortDescription] = useState(null);
  const [longDescription, setLongDescription] = useState(null);
  const [marketedBy, setMarketedBy] = useState(null);
  const [totalRatings, setTotalRatings] = useState(null);
  const [averageRating, setAverageRating] = useState(null);
  const [checkedDiv, setCheckedDiv] = useState(0);
  const [dataLoading, setDataLoading] = useState(true);
  const [shareBtn, setShareBtn] = useState(false);
  const [openModal, setOpenModal] = useState(false); // state to handle LoginModal
  const [itemType, setItemType] = useState("");
  const [selectedVariantImg, setSelectedVariantImg] = useState(null);
  const [done, setDone] = useState(false);
  const [qtyInCart, setQtyInCart] = useState(null);
  const [cartLineId, setCartLineId] = useState(null);
  const [isInCart, setIsInCart] = useState([]);
  const { setcart, setcartamount, cartItems, setCartItems, storeStatus } =
    useContext(store);
  const [modalSide, setModalSide] = useState(""); // state to switch between sign up and login
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  useEffect(() => {
    Notiflix.Loading.Init({
      svgColor: "#0f3d74",
    });

    localStorage.removeItem("ReviewPage");
    PostApiCall.postRequest(
      {
        id: parseInt(params.variantid),
        // customerid: null,
      },
      "GetProductByVariant"
    ).then((results) =>
      results.json().then((obj) => {
        if (results.status == 200 || results.status == 201) {
          setProductDetail(obj.data);
          setDone(true);
          Notiflix.Loading.Remove();
          for (var i = 0; i < Object.keys(obj.data).length; i++) {
            if (obj.data[i].fld_variantid == params.variantid) {
              setItemType(obj.data[i]?.item_type);
              setSelectedVariant(obj.data[i]);
              setMRP(obj.data[i].fld_mrp);
              setDiscountPrice(obj.data[i].fld_selling_price);
              setSavePer(obj.data[i].fld_discount_percent);
              setYouSave(obj.data[i].YouSave);
              setStock(obj.data[i].available_stockobj);
              setVariantId(obj.data[i].fld_variantid);
              setItemName(obj.data[i].fld_itemname);
              setVariantName(obj.data[i].fld_variantname);
              setCategoryName(obj.data[i].fld_categoryname);
              setQtyInCart(obj.data[i].qty_in_cart);
              setCartLineId(obj.data[i].cart_line_id);
              setRating(obj.data[i].fld_categoryname);
              setWeight(obj.data[i].weight);
              setCountryOfOrigin(obj.data[i].fld_origin_country);
              setShortDescription(obj.data[i].fld_short_description);
              setLongDescription(obj.data[i].fld_long_description);
              setMarketedBy(obj.data[i].fld_marketedby);
              setTotalRatings(obj.data[i].total_ratings);
              setAverageRating(obj.data[i].avg_rating);
              setItemName(obj.data[i].fld_itemname);
              setDataLoading(false);
              getAttributevalue(obj.data[i].fld_categoryid);
              PostApiCall.postRequest(
                {
                  variantid: parseInt(obj.data[i].fld_categoryid),
                },
                "GetRelatedProduct"
              ).then((results) =>
                // const objs = JSON.parse(result._bodyText)
                results.json().then((obj1) => {
                  if (results.status == 200 || results.status == 201) {
                    setRelatedProductDetail(obj1.data);
                    setDataLoading(false);
                  }
                })
              );
            }
          }
        }
      })
    );
  }, []);
  useEffect(() => {
    const InCart = cartItems.find((item) => {
      if (item.fld_variantid == params.variantid) {
        return item;
      }
    });
    setIsInCart(InCart);
  }, [cartItems]);
  const handleChangeModalSide = (e) => {
    setModalSide(e);
  };

  const getAttributevalue = (id) => {
    PostApiCall.postRequest(
      {
        id: parseInt(id),
      },
      "GetCategoryAttributeValue"
    )
      .then((res) => res.json())
      .then((res1) => {
        if (res1.data) {
        }
      });
  };

  const getCartdetails = () => {
    var login = localStorage.getItem("CustomerData");
    var logindetails = JSON.parse(login);

    var Order = localStorage.getItem("OrderData");
    var Orderdetails = JSON.parse(Order);

    PostApiCall.postRequest(
      {
        orderid:
          localStorage.getItem("OrderData") == null
            ? null
            : Orderdetails[0].order_id,
        id:
          localStorage.getItem("CustomerData") == null
            ? null
            : logindetails[0].fld_customerid,
      },
      "GetCartWebsite"
    )
      .then((res) => res.json())
      .then((res1) => {
        if (res1.data) {
          setCartItems(res1.data);
          setcart(res1?.data.reduce((a, v) => (a = a + v.fld_quantity), 0));
          // setcartamount(res1.data[0].fld_cart_amount_preview);
        }
      });
  };

  // login modal toggle
  const handleToggleModal = () => {
    setOpenModal(false);
  };

  const productsliderdemo = {
    dots: false,
    infinite: false,
    autoplay: true,
    arrows: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    initialSlide: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1290,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 2,
          initialSlide: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          arrows: true,
          nextArrow: <NextArrow />,
          prevArrow: <PrevArrow />,
        },
      },
    ],
  };

  const writeTextInClipboard = (url) => {
    navigator.clipboard
      .writeText(url)
      .then(() => {
        Notiflix.Notify.Success("Link copied to clipboard");
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  };
  return (
    <div>
      <GetSeoData type="Variant" id={params.variantid} />
      <LoginModal
        isOpen={openModal}
        handleToggleModal={handleToggleModal}
        handleChangeModalSide={handleChangeModalSide}
      />
      {/* <InnerBanner /> */}
      {dataLoading == true ? (
        <div className="container-fluid">
          <div className="row pt-4">
            <div className="col-md-5">
              <div className="large-img product-detail-img">
                <Skeleton.Image className="h-100 w-100" />
              </div>
              <div className="col-12 d-flex flex-wrap mt-4">
                <div className="thumbnail-img row w-100">
                  <Skeleton.Image />
                </div>
              </div>
            </div>
            <div className="col-md-7">
              <Skeleton active />
              <div className="mt-5">
                <Skeleton.Image />
              </div>
              <div className="buttons flex-column detailsbtn mb-0">
                <h2 className="prod-price">
                  <Skeleton.Button />
                </h2>
              </div>
              <div className="mt-3">
                <Skeleton.Input />
              </div>
            </div>
          </div>
          <div className="mt-4">
            <Skeleton />
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="my-4">
                <Skeleton.Input />
              </div>
            </div>
          </div>
          <div className="d-flex product-card-section justify-content-between flex-wrap">
            <div className="product-img-skeleton">
              <Skeleton.Image className="h-100 w-100" />
              <div className="buttons flex-column detailsbtn mb-0">
                <h2 className="prod-price">
                  <Skeleton.Button />
                </h2>
              </div>
              <div className="mt-3">
                <Skeleton.Input />
              </div>
            </div>
            <div className="product-img-skeleton">
              <Skeleton.Image className="h-100 w-100" />
              <div className="buttons flex-column detailsbtn mb-0">
                <h2 className="prod-price">
                  <Skeleton.Button />
                </h2>
              </div>
              <div className="mt-3">
                <Skeleton.Input />
              </div>
            </div>
            <div className="product-img-skeleton">
              <Skeleton.Image className="h-100 w-100" />
              <div className="buttons flex-column detailsbtn mb-0">
                <h2 className="prod-price">
                  <Skeleton.Button />
                </h2>
              </div>
              <div className="mt-3">
                <Skeleton.Input />
              </div>
            </div>
            <div className="product-img-skeleton">
              <Skeleton.Image className="h-100 w-100" />
              <div className="buttons flex-column detailsbtn mb-0">
                <h2 className="prod-price">
                  <Skeleton.Button />
                </h2>
              </div>
              <div className="mt-3">
                <Skeleton.Input />
              </div>
            </div>
            <div className="product-img-skeleton">
              <Skeleton.Image className="h-100 w-100" />
              <div className="buttons flex-column detailsbtn mb-0">
                <h2 className="prod-price">
                  <Skeleton.Button />
                </h2>
              </div>
              <div className="mt-3">
                <Skeleton.Input />
              </div>
            </div>
            <div className="product-img-skeleton">
              <Skeleton.Image className="h-100 w-100" />
              <div className="buttons flex-column detailsbtn mb-0">
                <h2 className="prod-price">
                  <Skeleton.Button />
                </h2>
              </div>
              <div className="mt-3">
                <Skeleton.Input />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="my-4">
                <Skeleton.Input />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 col-lg-4 product-reviews">
              <div className="overall-ratings">
                <Skeleton.Image className="ratings-skeleton-image" />
                <div className="d-flex flex-column w-100">
                  <div className="ratings">
                    <Skeleton />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-8 arrow-section">
              <Skeleton />
            </div>
          </div>
        </div>
      ) : (
        <>
          <section className="page-padding products-inner account-bg px-lg-3">
            <div className="container-fluid">
              <div className="row mt-0 mt-md-5 mt-lg-0 pt-4">
                <div className="col-md-6 col-lg-5">
                  <div className="w-card products-view">
                    <div className="row">
                      <div className="col-12">
                        <div className="large-img position-relative product-detail-img">
                          <img
                            src={
                              selectedVariantImg == undefined
                                ? variantImage == null
                                  ? selectedVariant.VariantImage
                                  : variantImage.split("$")[0]
                                : selectedVariantImg
                            }
                            alt="product images"
                            s="true"
                            className="img-fluid"
                          />
                        </div>
                      </div>
                      <div className="col-12 d-flex flex-wrap mt-4">
                        <div
                          className="thumbnail-img d-flex white-scrollbar w-100"
                          style={{
                            overflowX: "auto",
                          }}>
                          {selectedVariant &&
                            selectedVariant.VariantImage &&
                            variantImage == null
                            ? selectedVariant.VariantImage.split("#").map(
                              (url, index) => (
                                <div
                                  className="swiper-slide col-2 me-3 ps-0"
                                  key={index}>
                                  <img
                                    src={url}
                                    onClick={() => {
                                      setSelectedVariantImg(url);
                                    }}
                                    className="img-fluid"></img>
                                </div>
                              )
                            )
                            : variantImage != null
                              ? variantImage.split("$").map((url, index) => (
                                <div
                                  className="swiper-slide col-2 me-3 ps-0"
                                  key={index}>
                                  <img
                                    src={url}
                                    onMouseOver={() => {
                                      setSelectedVariantImg(url);
                                    }}
                                    className="img-fluid"></img>
                                </div>
                              ))
                              : ""}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-lg-7 ">
                  <div className="w-card pb-0">
                    <div
                      className={
                        selectedVariant.variant_list !== null
                          ? "product-detail-content ps-lg-4 d-flex flex-column justify-lg-between"
                          : "product-detail-content ps-lg-4 d-flex flex-column"
                      }>
                      <div>
                        <span className="productItemName">{categoryName}</span>
                        <div className="position-relative">
                          <h1 className="prod-title my-2 my-lg-0 pe-4 pe-lg-5 fs-2">
                            {itemName} - {variantName}
                            {/* {weight} */}
                          </h1>
                          <div className="product-share-btns">
                            <ul
                              className={
                                shareBtn == true ? "activ-share-btn" : ""
                              }>
                              <span
                                onClick={() => setShareBtn(!shareBtn)}
                                className="p-share-btn">
                                <FaShareAlt />
                              </span>
                              <li>
                                <FacebookShareButton
                                  url={`https://rubyfood.com/productdetail/${itemName?.replace(
                                    /\s/g,
                                    "-"
                                  )}-
                                    ${variantName?.replace(
                                    /\s/g,
                                    "-"
                                  )}/${variantId}`}
                                  quote={variantName}>
                                  <FaFacebookF />
                                </FacebookShareButton>
                              </li>
                              <li>
                                <WhatsappShareButton
                                  url={`https://rubyfood.com/productdetail/${itemName?.replace(
                                    /\s/g,
                                    "-"
                                  )}-${variantName?.replace(
                                    /\s/g,
                                    "-"
                                  )}/${variantId}`}
                                  quote={variantName}>
                                  <FaWhatsapp />
                                </WhatsappShareButton>
                              </li>
                              <li>
                                <TwitterShareButton
                                  url={`https://rubyfood.com/productdetail/${itemName?.replace(
                                    /\s/g,
                                    "-"
                                  )}-
                                    ${variantName?.replace(
                                    /\s/g,
                                    "-"
                                  )}/${variantId}`}
                                  quote={variantName}>
                                  {/* <img src={twitterx} /> */}
                                  <BsTwitterX />
                                </TwitterShareButton>
                              </li>
                              <li>
                                <LinkedinShareButton
                                  url={`https://rubyfood.com/productdetail/${itemName?.replace(
                                    /\s/g,
                                    "-"
                                  )}-
                                    ${variantName?.replace(
                                    /\s/g,
                                    "-"
                                  )}/${variantId}`}
                                  quote={variantName}>
                                  <FaLinkedinIn />
                                </LinkedinShareButton>
                              </li>
                              <li
                                onClick={() =>
                                  writeTextInClipboard(
                                    `https://rubyfood.com/productdetail/${itemName?.replace(
                                      /\s/g,
                                      "-"
                                    )}-${variantName?.replace(
                                      /\s/g,
                                      "-"
                                    )}/${variantId}`
                                  )
                                }>
                                <button className="border-0">
                                  <MdContentCopy />
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                        {totalRatings > 0 ? (
                          <div className="fs-14 d-flex align-items-center mb-2 mb-lg-4 mt-1">
                            <span>{averageRating}</span>
                            <i className="css-w0v4um  mx-1">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="13"
                                height="14">
                                <title>star</title>
                                <path
                                  fill="#000"
                                  d="M2.555 11.878c-.05 0-.1-.025-.15-.05a.277.277 0 01-.1-.275l1.098-4.092L.109 4.79c-.1-.05-.125-.175-.1-.275a.24.24 0 01.225-.174l4.242-.225L5.998.15c.05-.075.15-.15.25-.15s.2.075.225.15l1.522 3.967 4.242.225c.1 0 .2.075.225.174.025.1 0 .2-.075.275L9.093 7.46l1.098 4.092c.025.1 0 .2-.1.275-.075.05-.2.075-.274 0L6.248 9.532l-3.569 2.296c-.05.05-.075.05-.124.05z"></path>
                              </svg>
                            </i>
                            <span>({totalRatings} Reviews)</span>
                          </div>
                        ) : (
                          ""
                        )}
                        <p className="prod-number" style={{ fontSize: "14px" }}>
                          Sold by:{" "}
                          <span style={{ color: "#221f1f", fontSize: "14px" }}>
                            {marketedBy}
                          </span>
                          <br />
                          Country of Origin:{" "}
                          <span style={{ color: "#221f1f" }}>
                            {countryOfOrigin}
                          </span>
                        </p>
                        <p className="product-short-description pe-lg-5 me-lg-4">
                          {shortDescription &&
                            Parser(
                              ("" + shortDescription + "")
                                .replace(/font-family/g, "")
                                .replace(/<br\/?>/gi, " ")
                            )}
                        </p>
                        {selectedVariant.variant_list !== null ? (
                          <div className="variants my-3 my-lg-4">
                            <p>Available in</p>
                            <div className="d-flex flex-wrap">
                              {selectedVariant.variant_list == "" ||
                                selectedVariant.variant_list == null
                                ? ""
                                : selectedVariant.variant_list
                                  .split("#")
                                  .map((carddata, index) => (
                                    <div
                                      key={index}
                                      className={
                                        carddata
                                          .split("#")[0]
                                          .split("$")[1]
                                          .split(",")[1] != checkedDiv
                                          ? "detailscard"
                                          : "detailscard detailscard2"
                                      }
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        history.push(
                                          `/productdetail/${itemName?.replace(
                                            /\s/g,
                                            "-"
                                          )}-${carddata.split("#")[0].split("$")[1].split(",")[0]
                                            ?.replace(/\s/g, "-")}/${carddata
                                              .split("#")[0]
                                              .split("$")[1]
                                              .split(",")[1]
                                          }`
                                        );
                                        getCartdetails();
                                        setCheckedDiv(
                                          carddata
                                            .split("#")[0]
                                            .split("$")[1]
                                            .split(",")[1]
                                        );
                                        setVariantList(carddata);
                                        setMRP(
                                          carddata
                                            .split("#")[0]
                                            .split("$")[1]
                                            .split(",")[2]
                                        );
                                        setDiscountPrice(
                                          carddata
                                            .split("#")[0]
                                            .split("$")[1]
                                            .split(",")[3]
                                        );
                                        setSavePer(
                                          carddata
                                            .split("#")[0]
                                            .split("$")[1]
                                            .split(",")[4]
                                        );
                                        setYouSave(
                                          carddata
                                            .split("#")[0]
                                            .split("$")[1]
                                            .split(",")[5]
                                        );
                                        setStock(
                                          carddata
                                            .split("#")[0]
                                            .split("$")[1]
                                            .split(",")[6]
                                        );
                                        setVariantId(
                                          carddata
                                            .split("#")[0]
                                            .split("$")[1]
                                            .split(",")[1]
                                        );
                                        setVariantName(
                                          carddata
                                            .split("#")[0]
                                            .split("$")[1]
                                            .split(",")[0]
                                        );
                                        setWeight(
                                          carddata.split("$")[0].split(",")[0]
                                        );
                                        setCategoryName(
                                          carddata
                                            .split("#")[0]
                                            .split("$")[1]
                                            .split(",")[8]
                                        );
                                        setVariantImage(
                                          carddata.split("#")[0].split(",")[7]
                                        );
                                      }}>
                                      <img
                                        src={
                                          carddata
                                            .split("#")[0]
                                            .split("$")[1]
                                            .split(",")[7]
                                            .split("~")[0]
                                        }
                                      />

                                      <div>
                                        <p>
                                          {
                                            carddata
                                              .split("#")[0]
                                              .split("$")[1]
                                              .split(",")[0]
                                          }
                                        </p>
                                      </div>
                                    </div>
                                  ))}
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="buttons flex-column detailsbtn mb-0">
                        <h2 className="prod-price">
                          ₹{" "}
                          {isNaN(parseFloat(discountPrice).toFixed(2))
                            ? {}
                            : parseFloat(discountPrice).toFixed(2)}{" "}
                          {!isNaN(parseFloat(youSave).toFixed(2)) &&
                            !isNaN(parseFloat(savePer).toFixed(2)) && (
                              <span
                                style={{
                                  display:
                                    discountPrice == mrp ? "none" : "block",
                                }}>
                                <span className="dis-p">
                                  MRP:&nbsp;
                                  <s>
                                    ₹
                                    {isNaN(parseFloat(mrp).toFixed(2))
                                      ? "0"
                                      : parseFloat(mrp).toFixed(2)}{" "}
                                  </s>
                                </span>
                                <br></br>
                                <div
                                  className="prod-yousave"
                                  style={{
                                    display:
                                      discountPrice == mrp ? "none" : "block",
                                  }}>
                                  You Save:{" "}
                                  <em>
                                    {" "}
                                    <i className="fas fa-rupee-sign"></i> ₹
                                    {isNaN(parseFloat(youSave).toFixed(2))
                                      ? {
                                        /* <Loader /> */
                                      }
                                      : parseFloat(youSave).toFixed(2)}
                                    ({" "}
                                    {isNaN(parseFloat(savePer).toFixed(2))
                                      ? ""
                                      : parseFloat(savePer).toFixed(2)}
                                    %)
                                  </em>
                                </div>
                              </span>
                            )}
                        </h2>
                        {storeStatus == "Active" && (
                          <div className="mt-3">
                            {isInCart ? (
                              <AddToCartQty
                                itemid={variantId}
                                quantity={isInCart.fld_quantity}
                                cartlineid={isInCart.fld_cart_dtl_id}
                              />
                            ) : (
                              <span className="theme-btn cursor-pointer">
                                <AddToCart itemid={variantId} />
                              </span>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* remove this comment later */}
          <section
            className="section-padding mt-4 mt-lg-3 px-lg-3"
            style={{ background: "#fff" }}>
            {relatedProductDetail.length > 0 ? (
              <>
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-md-8 product-detail-accordion mt-0">
                      <div className="section-title mt-md-5 mt-lg-2">
                        <h2 className="">Product Details</h2>
                        <div className="title-divider"></div>
                      </div>
                      {longDescription
                        ? <div className="product-long-description"> {Parser(
                          ("" + longDescription + "")
                            .replace(/font-family/g, "")
                            .replace(/<br\/?>/gi, " ")
                        )}
                        </div>

                        : "No Description Available"}
                    </div>
                  </div>
                </div>
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="section-title mt-2">
                        <h2 className="text-left section-title-category-section">
                          Related Products
                        </h2>
                        {/* <div className="title-divider"></div> */}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 arrow-section product-card-section">
                      {relatedProductDetail.length > 0 ? (
                        <div className="main-slider-box related-product-slider white-scrollbar">
                          <Slider {...productsliderdemo}>
                            {relatedProductDetail.map((item) => {
                              const isCart = cartItems.find((val) => {
                                if (item.fld_variantid === val.fld_variantid) {
                                  return val;
                                }
                              });
                              return (
                                <RelatedProducts
                                  itemdata={item}
                                  key={item.fld_variantid}
                                  isInCart={isCart}
                                />
                              );
                            })}
                          </Slider>
                        </div>
                      ) : (
                        <div className="d-flex">
                          <div className="item">
                            <div className="product-box">
                              <Skeleton.Image className="p-images blog-images" />
                              <Skeleton.Button className="content-box position-relative" />
                            </div>
                          </div>
                          <div className="item">
                            <div className="product-box">
                              <Skeleton.Image className="p-images blog-images" />
                              <Skeleton.Button className="content-box position-relative" />
                            </div>
                          </div>
                          <div className="item d-none d-lg-block">
                            <div className="product-box">
                              <Skeleton.Image className="p-images blog-images" />
                              <Skeleton.Button className="content-box position-relative" />
                            </div>
                          </div>
                          <div className="item d-none d-lg-block">
                            <div className="product-box">
                              <Skeleton.Image className="p-images blog-images" />
                              <Skeleton.Button className="content-box position-relative" />
                            </div>
                          </div>
                          <div className="item d-none d-lg-block">
                            <div className="product-box">
                              <Skeleton.Image className="p-images blog-images" />
                              <Skeleton.Button className="content-box position-relative" />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              "Not avaiable now"
            )}
          </section>
          <div className="px-lg-3">
            <ProductReviews
              variantid={params.variantid}
              variantName={variantName}
              variantimage={selectedVariant.VariantImage}
            />
          </div>
        </>
      )}
    </div>
  );
}
